<div class="cb-filetype-icon" [ngClass]="['cb-type-' + type()]" [innerHTML]="svgContent()"></div>